import { observer } from 'mobx-react-lite';

import type { VideoBroadcastWidgetState } from '../store/VideoBroadcastWidgetState';

import styles from './VideoBroadcastWidget.module.scss';

export const AdditionalInfo = observer(function AdditionalInfo({
  widgetState,
  holeDepthLabel,
  bitDepthLabel,
}: {
  widgetState: VideoBroadcastWidgetState;
  holeDepthLabel: string;
  bitDepthLabel: string;
}) {
  const { kpi, depthHole, operations, depthBit } = widgetState.additionalInfo;
  const {
    depthHoleCurveId,
    depthHoleNameAndUom,
    depthHoleLastValue,
    kpiCurveId,
    operationsCurveId,
    depthBitCurveId,
    depthBitNameAndUom,
    depthBitLastValue,
  } = widgetState;
  const bottomBadge = kpi || depthHole || operations || depthBit;
  const bottomBadgeHasInfo = depthHoleCurveId || operationsCurveId || kpiCurveId || depthBitCurveId;

  if (!bottomBadge || !bottomBadgeHasInfo) {
    return null;
  }

  return (
    <div className={styles.additionalInfoBadge}>
      {depthHoleCurveId && depthHole && (
        <div className={styles.additionalInfoElem}>
          {depthHoleNameAndUom && <span>{holeDepthLabel}</span>}
          <span className={styles.valueText}>{depthHoleLastValue}</span>
          {depthHoleNameAndUom && <span>{depthHoleNameAndUom.uom}</span>}
        </div>
      )}
      {depthBitCurveId && depthBit && (
        <div className={styles.additionalInfoElem}>
          {depthBitNameAndUom && <span>{bitDepthLabel}</span>}
          <span className={styles.valueText}>{depthBitLastValue}</span>
          {depthBitNameAndUom && <span>{depthBitNameAndUom.uom}</span>}
        </div>
      )}
    </div>
  );
});
